/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UboDeclarationResource } from './';
import {
    UboDeclarationResourceFromJSON,
    UboDeclarationResourceFromJSONTyped,
    UboDeclarationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UboResource
 */
export interface UboResource {
    /**
     * 
     * @type {UboDeclarationResource}
     * @memberof UboResource
     */
    uboDeclaration?: UboDeclarationResource;
}

/**
 * Check if a given object implements the UboResource interface.
 */
export function instanceOfUboResource(value: object): value is UboResource {
    return true;
}

export function UboResourceFromJSON(json: any): UboResource {
    return UboResourceFromJSONTyped(json, false);
}

export function UboResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboResource {
    if (json == null) {
        return json;
    }
    return {
        
        'uboDeclaration': json['uboDeclaration'] == null ? undefined : UboDeclarationResourceFromJSON(json['uboDeclaration']),
    };
}

export function UboResourceToJSON(value?: UboResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'uboDeclaration': UboDeclarationResourceToJSON(value['uboDeclaration']),
    };
}

